import { message } from 'antd';
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWith409 from './baseQueryWith409';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';

// direct fetch without RTK Query
export const getEstadosProcesos = query =>
	fetch.get(
		`/estados-procesos${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const getEstadoProceso = ({ id, query }) =>
	fetch.get(
		`/estados-procesos/${id}${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const addEstadoProceso = data => fetch.post('/estados-procesos', data);
export const updateEstadoProceso = ({ id, ...data }) =>
	fetch.put(`/estados-procesos/${id}`, data);
export const deleteEstadoProceso = id =>
	fetch.delete(`/estados-procesos/${id}`);

// RTK Query
export const estadosProcesosApi = createApi({
	reducerPath: 'estadosProcesosApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getEstadosProcesos: build.query({
			query: query => {
				return {
					url: `/estados-procesos${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({
								type: 'EstadosProcesos',
								id,
							})),
							{ type: 'EstadosProcesos', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'EstadosProcesos', id: 'LIST' }],
		}),
		getEstadoProceso: build.query({
			query: ({ id, query }) => {
				return {
					url: `/estados-procesos/${id}${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [{ type: 'EstadosProcesos', id }],
		}),
		addEstadoProceso: build.mutation({
			query: data => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/estados-procesos`,
					method: 'POST',
					body: JSON.stringify({
						data: {
							...data,
							created_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Estado Proceso agregado exitosamente');
				} catch (error) {
					message.error('Error al agregar estado proceso');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: [{ type: 'EstadosProcesos', id: 'LIST' }],
		}),
		updateEstadoProceso: build.mutation({
			query: ({ id, ...data }) => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/estados-procesos/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							...data,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Estado Proceso actualizado exitosamente');
				} catch (error) {
					message.error('Error al actualizar estado proceso');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, { id }) => [
				{ type: 'EstadosProcesos', id },
			],
		}),
		deleteEstadoProceso: build.mutation({
			query: id => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/estados-procesos/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							publishedAt: null,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Estado Proceso eliminado exitosamente');
				} catch (error) {
					message.error('Error al eliminar estado proceso');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, id) => [
				{ type: 'EstadosProcesos', id },
			],
		}),
	}),
});

export const {
	useGetEstadosProcesosQuery,
	useGetEstadoProcesoQuery,
	useAddEstadoProcesoMutation,
	useUpdateEstadoProcesoMutation,
	useDeleteEstadoProcesoMutation,
} = estadosProcesosApi;
